import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, getFormValues } from 'redux-form'
import Calendar from 'react-calendar';
import Moment from 'react-moment'
import { 
  Icon,
  Input,
  Form,
  Dropdown,
  Button } from  'semantic-ui-react'
import {
  Collapse } from '@material-ui/core';

import { 
  SearchCont,
  InputCont,
  AdvanceCont,
  FiledRowContent,
  DateCont } from './styled'
import { 
  fetchProjects,
  fetchStatusPOWorkSpace } from 'ducks/options'
import { 
  fetchWorkList } from 'ducks/workList'

const SearchWorkspace = (props) => {
  const {
    projects,
    handleSubmit,
    reset,
    valueForm
  } = props

  const [visibleAS,setVisibleAS] = React.useState(false)
  const [visibleSelectDate,setVisibleSelectDate] = React.useState(false)
  const [date,setDate] = React.useState('')

  React.useEffect(()=>{
    props.fetchStatusPOWorkSpace()
    props.fetchProjects()
  },[])

  return (
    <SearchCont>
      <Form onSubmit={handleSubmit(()=>onAdvanceSearchClick())}>
      <InputCont>
        <Field name="searchKey" onSearchClick={()=>onAdvanceSearchClick()} component={renderInputSearch} onEnter={()=>onAdvanceSearchClick()}/> 
        <Icon name='settings' circular inverted link onClick={()=>setVisibleAS(!visibleAS)}/>
      </InputCont>
      <Collapse in={visibleAS} timeout="auto" unmountOnExit>
        <AdvanceCont>
          <Field label="Process" name="processCode" component={renderDropdown} 
            onChange={(event, newValue)=>onAdvanceSearchClick({processCode:newValue})}
            option={[
              {value:'-',text:'All Process'},
              {value:'PurchaseRequisition',text:'Purchase Requisition'},
              {value:'RFQ',text:'Request for Quotation'},
              {value:'PurchaseOrder',text:'Purchase Order'}
          ]}/>

          <Field label="Date Range Type" name="dateRangeType" component={renderDropdown} 
            onChange={(event, newValue)=>setVisibleSelectDate(true)}
            option={[
              {value:'-',text:'All Date Range'},
              {value:'ReceiveOn',text:'Received Date'},
              {value:'SubmittedOn',text:'Submitted Date'},
            ]}/>
          
          <DateCont>
            <Moment format="DD MMM YYYY">{date[0]||Date.now()}</Moment>
            {`  -  `}
            <Moment format="DD MMM YYYY">{date[1]||Date.now()}</Moment>
          </DateCont>
          <Icon name='calendar alternate outline' circular inverted link onClick={()=>setVisibleSelectDate(!visibleSelectDate)}/>
           
          <Field label="Project" name="projectId" component={renderDropdown} 
            onChange={(event, newValue)=>onAdvanceSearchClick({projectId:newValue})}
            search={true}
            option={[
              {key:'bb',value:0,text:'All Project'},
              ...setProjects()
            ]}/>
          <Button type='button' style={{marginLeft:'1rem'}} onClick={()=>reset(onResetClick())}>Clear</Button>
        </AdvanceCont>
        <AdvanceCont>
          {valueForm&&valueForm.processCode=='PurchaseOrder'?
          <Field label="Status" name="poStatus" component={renderDropdown} 
            onChange={(event, newValue)=>onAdvanceSearchClick({poStatus:newValue})}
            option={[
              {key:'aa',value:'-',text:'All Status'},
              ...props.statusPOWorkSpace
            ]}
          />:null}
        </AdvanceCont>
        <Collapse in={visibleSelectDate} timeout="auto" unmountOnExit>
          <div style={{marginTop:'0.5rem'}}>
            <Calendar
              onChange={(date)=>{
                setDate(date)
                setVisibleSelectDate(false)
                onAdvanceSearchClick(null,date)
              }}
              value={date}
              selectRange={true}
            />
          </div>
        </Collapse>
      </Collapse>
      </Form>
    </SearchCont>
  )

  function setProjects(){
    if(projects){
      return projects.sort((a, b) => a.text?a.text.localeCompare(b.text):-1)
    }
    return []
  }

  function onResetClick(){
    setDate('')
    props.fetchWorkList()
  }

  function onAdvanceSearchClick(data,dateI){
    props.fetchWorkList({...valueForm,date:dateI?dateI:date,...data})
  }
}

const renderDropdown = props => {
  return (
    <FiledRowContent>
      <Dropdown 
        selection
        value={props.input.value}
        fluid
        search={props.search||false}
        onChange={(param,data) => {props.input.onChange(data.value)}}
        placeholder={props.label} 
        options={props.option}
      />
    </FiledRowContent>
  )
}

const renderInputSearch = props => {
  const {input,onSearchClick} = props
  return (
    <Input 
    {...input}
    onKeyDown={(e)=>{
      if (e.key === 'Enter') {
        if(props.visibleAS) props.onEnter()
      }
    }}
    className='searchInput' 
    icon={<Icon type='submit' name='search' inverted circular link onClick={()=>onSearchClick()}/>} 
    placeholder='Doc No., Title, Requester' />
  )
}

const mapStateToProps = (state) => {
  return ({
    initialValues: {
      processCode:'-',
      dateRangeType:'-',
      projectId:0,
      searchKey:'',
      poStatus:'-'
    },
    valueForm: getFormValues('formSearchWorkspace')(state),
    companies: state.options.companies.data,
    projects: state.options.projects.data,
    statusPOWorkSpace: state.options.statusPOWorkSpace.data
  })
}
const mapDispatchToProps = {
  fetchWorkList,
  fetchProjects,
  fetchStatusPOWorkSpace
}

const contForm = reduxForm({
  form: 'formSearchWorkspace',
  enableReinitialize: true,
})(SearchWorkspace)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)